import React, {useEffect, useState} from "react";
import {Fade as AwesomeFade, Slide as AwesomeSlide} from "react-awesome-reveal";

const MAX_DURATION = 450;

function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReduced(media.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return reduced;
}

function directionFromProps({left, right, bottom, top, up}) {
  if (left) return "left";
  if (right) return "right";
  if (bottom) return "up";
  if (top || up) return "down";
  return "up";
}

export function Fade({
  children,
  duration = 1000,
  left,
  right,
  bottom,
  top,
  up,
  ...rest
}) {
  delete rest.distance;
  const reduced = usePrefersReducedMotion();
  if (reduced) {
    return <>{children}</>;
  }

  return (
    <AwesomeFade
      direction={directionFromProps({left, right, bottom, top, up})}
      duration={Math.min(duration, MAX_DURATION)}
      triggerOnce
      fraction={0.15}
      {...rest}
    >
      {children}
    </AwesomeFade>
  );
}

export function Slide({children, duration = 1000, left, right, ...rest}) {
  delete rest.distance;
  const reduced = usePrefersReducedMotion();
  if (reduced) {
    return <>{children}</>;
  }

  return (
    <AwesomeSlide
      direction={left ? "left" : right ? "right" : "left"}
      duration={Math.min(duration, MAX_DURATION)}
      triggerOnce
      fraction={0.15}
      {...rest}
    >
      {children}
    </AwesomeSlide>
  );
}
